// 預覽模塊
export default {
    Preview: {
        ExitPreview: '退出預覽',
        Tip: '提示：當前為預覽頁面，答題不被記錄',
        MobilePhone: '手機',
        Computer: '電腦',
        ReferenceThisTemplate: '引用該模板',
        InReference: '引用中'
    },
  };